import React from 'react';
import {useIntl} from 'react-intl';
import {View, Text} from '@unthinkable/react-core-components';
import {useStyles} from '@unthinkable/react-theme';
import { profileStyle } from '../styles/Profile.styles';

function Profile(props) {
  const intl = useIntl();
  const styles = useStyles(profileStyle);

  return (
    <View style={styles.container}>
      <Text style={styles.header}>
        {intl.formatMessage({id: 'label.profile'})}
      </Text>
    </View>
  );
}

export default Profile;
